import { render, staticRenderFns } from "./EmployeesTableRowSkeleton.vue?vue&type=template&id=6e67c358&scoped=true&lang=pug&functional=true"
import script from "./EmployeesTableRowSkeleton.vue?vue&type=script&lang=js"
export * from "./EmployeesTableRowSkeleton.vue?vue&type=script&lang=js"
import style0 from "./EmployeesTableRowSkeleton.vue?vue&type=style&index=0&id=6e67c358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6e67c358",
  null
  
)

export default component.exports